'use client'

import { useCallback, useState } from 'react'

/** How long a "Copied" confirmation stays on a button. */
const CONFIRM_MS = 2000

/**
 * Copy text and flag the button as copied for a moment. `copy` resolves
 * `false` when the browser refuses the clipboard, so the caller can offer
 * the text another way.
 */
export function useCopyToClipboard(): {
  isCopied: boolean
  copy: (text: string) => Promise<boolean>
} {
  const [isCopied, setIsCopied] = useState(false)
  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      return false
    }
    setIsCopied(true)
    window.setTimeout(() => setIsCopied(false), CONFIRM_MS)
    return true
  }, [])
  return { isCopied, copy }
}
